import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IClimateChangeStructureFormValues } from '../EsgGreenhouseFormProvider/types';

export const CLIMATE_CHANGE_STRUCTURE_INTRODUCTION_ID =
  'climate-change-structure-introduction';

const ClimateChangeStructureIntroduction = () => {
  const { control, getValues } = useGreenhouseForm();
  const { introduction } =
    getValues(`climateChangeStructure`) ??
    ({} as IClimateChangeStructureFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const climateChangeStructureIntroductionEl = document.getElementById(
    CLIMATE_CHANGE_STRUCTURE_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'climateChangeStructure',
      control,
    }) ?? ({} as IClimateChangeStructureFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        climateChangeStructureIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="กำหนดโครงสร้างการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ"
              setOpen={open}
              fieldPath="climateChangeStructure.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          climateChangeStructureIntroductionEl
        )}
    </>
  );
};

export default ClimateChangeStructureIntroduction;
